import { Stylable } from 'utils/types'
import { StyledSpinner } from './styles'

type Props = Stylable

export const Spinner = ({ style, className, color }: Props) => {
  return <StyledSpinner style={style} className={className} color={color} />
}
